<template>
    <div>
            <div class="kd">
        <div class="zziiz">教材邮寄快递EMS查询</div>
        <el-input
          class="jiaocai"
          placeholder="请输入内容"
          size="small"
          prefix-icon="el-icon-search"
          v-model="kuaidi"
          clearable
        ></el-input>
        <el-button type="primary" class="bqw" @click="chchch()">查询</el-button>
        <div class="kuadi" ref="kuadi">
         <!-- :class="activeClass" -->
          <div class="kuaiditu" v-show="emsStatus[0].isActive">
                <img
                    v-for="todo in emsStatus"
                    :key="todo.img"
                    :src="(todo.isActive?todo.active:todo.img)"
                    alt=""
                    class="tu11"
                    ref="tu11"
                />
          </div>
          <div class="dizhixin" ref="dizhixin">
            <div class="kuaidichauxn">
              <Timeline pending>
                  
                <template v-for="todo in list">
                    <TimelineItem :key="todo.opTime">
                        <span class="time">{{ todo.opTime }}</span>
                        <span class="content">{{ todo.opDesc }}</span>
                    </TimelineItem>
                </template>
              </Timeline>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import {
 
  queryTrace,
 
} from "network/home";
import {
  getNews,
} from "../../../network/LPersonal";
import { formatDate } from "common/utils";
import xiadan1 from "../../../assets/img/kuaidi/xiadan1.png";
import xiadan2 from "../../../assets/img/kuaidi/xiadan2.png";
import fahuo1 from "../../../assets/img/kuaidi/fahuo1.png";
import fahuo2 from "../../../assets/img/kuaidi/fahuo2.png";
import lanjian1 from "../../../assets/img/kuaidi/lanjian1.png";
import lanjian2 from "../../../assets/img/kuaidi/lanjian2.png";
import yunshu1 from "../../../assets/img/kuaidi/yunshu1.png";
import yunshu2 from "../../../assets/img/kuaidi/yunshu2.png";
import paijian1 from "../../../assets/img/kuaidi/paijian1.png";
import paijian2 from "../../../assets/img/kuaidi/paijian2.png";
import qianshou1 from "../../../assets/img/kuaidi/qianshou1.png";
import qianshou2 from "../../../assets/img/kuaidi/qianshou2.png";

export default {
    data(){
        // <img
        //       src="../../../assets/img/kuaidi/xiadan1.png"
        //       alt=""
        //       class="tu11"
        //       ref="tu11"
        //     />
        return{
            list: [],
            activeClass: "kuaidi0",
            emsStatus: [
                {
                    rule: (list) => {return list.length > 0 },
                    img: xiadan1,
                    active: xiadan2,
                    isActive: false
                },
                {
                    rule: (list) => {return list.length > 0 },
                    img: fahuo1,
                    active: fahuo2,
                    isActive: false
                },
                {
                    rule: (list) => { return list.find(todo=>todo.opCode == 203) },
                    img: lanjian1,
                    active: lanjian2,
                    isActive: false
                },
                {
                    rule: (list) => { return list.find(todo=>todo.opCode == 305) },
                    img: yunshu1,
                    active: yunshu2,
                    isActive: false
                },
                {
                    rule: (list) => { return list.find(todo=>todo.opCode == 702) },
                    img: paijian1,
                    active: paijian2,
                    isActive: false
                },
                {
                    rule: (list) => { return list.find(todo=>todo.opCode == 704) },
                    img: qianshou1,
                    active: qianshou2,
                    isActive: false
                },
            ],
            kuaidi: "",
            flagg: false,
            flag: false,      
        }
    },
    created(){
      this.$emit("editPage", "快递查询", "快递查询");
    },
    mounted(){
      this.$emit("editPage", "快递查询", "快递查询");
      if(this.$route.query.data){
        this.kuaidi = this.$route.query.data;
        this.chchch();
      }
      this.get();
    },
    methods:{
      
    // 接口方法
    get() {
      console.log(this.userId);
      getNews({
        userId: this.userId,
      }).then((r) => {
        console.log(r, "个人信息");
        this.formItem = r.data.data;
        
        // console.log(this.formItem.user.idCard);
      });
    },
          //快递
    chchch() {
        this.emsStatus.map(todo=>{todo.isActive = false;})
        this.activeClass = "";
      if (this.kuaidi === "") {
        this.$message({
          message: "请先输入单号",
          type: "warning",
        });
      } else {
       queryTrace(this.traceNo = this.kuaidi).then((res) => {
           console.error(res.data.code);
           if(res.data.code==200){
             this.list = res.data.data;
            for(var i = 0; i< this.emsStatus.length; i++){
                const todo = this.emsStatus[i]
                const isActive = todo.isActive = todo.rule(this.list);
                if(!todo.isActive) {
                  this.activeClass = `kuaidi${i-1}`;
                  break;
                }
            }
            return;
           } else{
             this.$Message.error(res.data.msg)
           }
          
       });
      
      }
    },
    },
    filters: {
    formatDate(time) {
    var date = new Date(time);
    return formatDate(date, 'yyyy.MM.dd'); 
   },
    
  }
}
</script>
<style lang="less" scoped>
.kd {
  width: 900px;
}
.zziiz {
  color: #4771ea;
  font-size: 16px;
  margin-left: 30px;

  margin-bottom: 10px;
}
.jiaocai {
  width: 650px;
  margin-left: 50px;
  margin-bottom: 20px;
}
.xiantiao1 {
  position: absolute;
  width: 90px;
  height: 2px;
  border: 1px dashed blue;
  top: 35px;
  left: 104px;
  display: none;
}
.xiantiao2 {
  position: absolute;
  width: 90px;
  height: 2px;
  border: 1px dashed blue;
  top: 35px;
  left: 254px;
  display: none;
}
.xiantiao3 {
  position: absolute;
  width: 90px;
  height: 2px;
  border: 1px dashed blue;
  top: 35px;
  left: 404px;
  display: none;
}
.xiantiao4 {
  position: absolute;
  width: 90px;
  height: 2px;
  border: 1px dashed blue;
  top: 35px;
  left: 554px;
  display: none;
}
.xiantiao5 {
  position: absolute;
  width: 90px;
  height: 2px;
  border: 1px dashed blue;
  top: 35px;
  left: 704px;
  display: none;
}
.kuadi {
  position: relative;
}
.tu2 {
  display: none;
}
.tu4 {
  display: none;
}
.tu6 {
  display: none;
}
.tu8 {
  display: none;
}
.tu10 {
  display: none;
}
.tu12 {
  display: none;
}
.bqw {
  height: 36px;
  margin-left: 20px;
  background: #3562e8;
}
.kuadi{
  width: 840px;
}
.kuaiditu {
  margin-top: 30px;
  width: 840px;
  height: 35px;
  position: relative;
  border-bottom: 1px solid #333;
}
.kuaiditu:after{
    content: "";
    position: absolute;
    left: 0;
    bottom: -1px;
    width: 840px;
    z-index: 1;
}
.kuaidi3:after{
    width: 364px;
}
.kuaiditu img {
  width: 66px;
  height: 87px;
  margin-right: 88px;
  position: relative;
  z-index: 2;
}
.kuaiditu img:nth-of-type(1){
    position: relative;
    left: -3px;
}
.kuaiditu img:nth-of-type(6){
    position: relative;
    right: -7px;
    margin-right: 0;
}
.time {
  display: inline-block;

  font-size: 14px;
  font-weight: bold;
  margin-left: 50px;
  height: 40px;
}
.content {
  display: inline-block;
  width: 280px;

  margin-left: 50px;
}
.dizhixin {
  margin-top: 100px;
  margin-left: 150px;
}
/deep/.ivu-timeline-item-content {
  width: 600px;
  display: flex;
  justify-content: space-between;
}
</style>